import { useState, useEffect, Fragment } from 'react';
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";


import PaymentSetupForm from './PaymentSetupForm';

import { useStore } from '../../../hook-store/store';
// import { 
//   cardExpire, 
//   getSetupIntent,
// } from '../../utils/stripe/payment-method-utils';

import { 
  BACKEND_URL,  
} from '../../../App';

function PaymentSetup(props) {

  const {
    setShowPaymentSetup,
  } = props;

  const [store, dispatch] = useStore();
  // const { freeSizeGB } = store.bucketObjectStore;
  const { 
    usageBasedPrice,
    usageBasedSubscription,
    customerMethods,
  } = store.stripeData;
  const { gLoading } = store.uiStore;

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const [stripePromise, setStripePromise] = useState('');
  const [clientSecret, setClientSecret] = useState('');

  const options = {
    // passing the client secret obtained in step 2
    clientSecret: clientSecret,
    // Fully customizable with appearance API.
    appearance: {/*...*/},
  };

  useEffect(() => {
    getStripPromise();
  },[]);

  // useEffect(() => {
  //   if (customerMethods.length > 0 && usageBasedSubscription) {
  //     const methodList = [];

  //     for (const method of customerMethods) {
  //       const cardExpired = cardExpire(method.card.exp_month, method.card.exp_year);
        
  //       if (!cardExpired) {
  //         methodList.push(method);
  //       }
  //     }
  
  //     console.log(methodList);
  //     // if (methodList.length === 1) {
  //     //   dispatch('SET_VALID_DEFAULTMETHOD', methodList[0]);
  //     // }
  
  //     if (methodList.length > 0) {
  //       const isSubscriptionMethod = methodList.find(method => {
  //         return method.id === usageBasedSubscription.default_payment_method;
  //       });

  //       if (isSubscriptionMethod) {
  //         dispatch('SET_USAGEBASEDVALIDMETHOD', isSubscriptionMethod);
  //       } else {
  //         dispatch('SET_USAGEBASEDVALIDMETHOD', null);
  //       }
  //     }
  //     else {
  //       dispatch('SET_USAGEBASEDVALIDMETHOD', null);
  //     }
  //   }
  // },[customerMethods, usageBasedSubscription]);

  useEffect(() => {
    if (stripePromise) {
      getSetupIntent();
    }
  },[stripePromise]);


  const showCardAddedHandler= () => {}
  const showCardInputHandler = () => {}

  const getStripPromise = () => {
    setIsLoading(true);

    fetch(BACKEND_URL + '/price/config')
      .then(r => {
        return r.json()
      })
      .then(resData => {
        console.log('stripe-config resData', resData);
        const stripePromise = loadStripe(resData.publishableKey);
        setStripePromise(stripePromise);
        setIsLoading(false);
    
      })
      .catch(err => {
        console.log('stripe-config err', err);
        setIsLoading(false);
      });
  };


  const getSetupIntent = async () => {
    try { 
      console.log('getSetupIntent')
      setIsLoading(true);
      const lsCustomerId = localStorage.getItem('customerId');
      
      if (lsCustomerId) {
        const response = await fetch(BACKEND_URL + `/payment-method/setup-intent?customerId=${lsCustomerId}`, {
          method: 'GET',
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token'),
            'Content-Type': 'application/json',
            // 'Accept': 'application/json',
          },
        });

        // console.log('getSetupIntent', response);


        if (response.ok) {
          const resData = await response.json();
          // console.log('getSetupIntent', response, resData);
          if (resData.client_secret) {
            setClientSecret(resData.client_secret);
          }

        } else {
          throw new Error('something wrong');
        }

        setIsLoading(false);
      }

    } catch(err) {
      console.log(err);
      setIsLoading(false);
    }
  };


  let paymentSetupBody;

  if (clientSecret && stripePromise) {
    paymentSetupBody = (
        <div>
          {/* <div>client-secret and stripe-promise there</div> */}
          <Elements stripe={stripePromise} options={options}>
            <PaymentSetupForm
              showCardAddedHandler={showCardAddedHandler}
              showCardInputHandler={showCardInputHandler}
              setShowPaymentSetup={setShowPaymentSetup}
            />
          </Elements>
        </div>
    )
  }




  return (
    <Fragment>
      <div>{paymentSetupBody}</div>
    </Fragment>
  );
}

export default PaymentSetup;
